<!-- removed this dialog box using same as Admin -> Driver -->
<div class="driver-view-container">
  <div class="trip-detail-popup-right">
    <img
      src="../../../assets/img/icons8-macos-close-60.png"
      class="close-icons"
      (click)="close()"
    />
  </div>
  <div class="driver-view" *ngIf="viewDriver">
    <div class="heading">
      <h3>Driver Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <div class="row">
      <div class="col-sm-9">
        <div class="row mtb">
          <div class="col-sm-5">
            <div class="head">Driver Name</div>
            <div class="dec">{{ driverData.registerInfo[0]?.username }}</div>
          </div>
          <div class="col-sm-7">
            <div class="dec">
              {{ driverData.registerInfo[0]?.mobile }}
              <img src="../../../assets/img/tick-verify.svg" />
            </div>
            <div class="dec">
              {{ driverData.registerInfo[0]?.email }}
              <img
                *ngIf="driverData.registerInfo[0]?.email_verified == 1"
                src="../../../assets/img/tick-verify.svg"
              />
            </div>
          </div>
        </div>
        <div class="row mtb">
          <div class="col-sm-5">
            <div class="head">Driving License Number</div>
            <div class="dec">
              {{ driverData.registerInfo[0]?.driving_license_number }}
            </div>
          </div>
          <div class="col-sm-7">
            <div class="head">Expire Date</div>
            <div class="dec">
              {{
                driverData.registerInfo[0]?.license_expiry_date
                  | date : "dd-MM-yyyy"
              }}
            </div>
          </div>
        </div>
        <div class="row mtb">
          <div class="col-sm-5">
            <div class="head">Assigned Truck Number</div>
            <div class="dec">
              {{ driverData.truckInfo[0]?.truck_number || null }}
            </div>
          </div>
          <div class="col-sm-7">
            <div class="head">Emergency Number</div>
            <div class="dec">
              {{ driverData.registerInfo[0]?.mobile }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="row mtb">
          <div class="col-md-12">
            <div class="right-side image">
              <img
                src="{{ driverData.registerInfo[0]?.profile_image }}"
                class="driverImg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mtb">
      <div class="col-sm-6">
        <div class="head">Contact Details</div>
        <div class="dec">
          {{ driverData.registerInfo[0].contact_details?.address_line }},
          {{ driverData.registerInfo[0]?.contact_details?.area }},
          {{ driverData.registerInfo[0]?.contact_details?.city }},
          {{ driverData.registerInfo[0]?.contact_details?.state }},
          {{ driverData.registerInfo[0]?.contact_details?.pincode }}.
        </div>
      </div>
    </div>
    <div>
      <div class="head mtb">Documents</div>
      <div class="row mtb">
        <div class="col-sm-4">
          <div class="head-b">Driving License</div>
        </div>
        <div class="col-sm-4">
          <div class="dec">
            {{
              driverData.registerInfo[0]?.documents?.driving_license_expiry
                | date : "dd-MM-yyyy"
            }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="dec-view">
            <a
              target="_blank"
              href="{{ data.registerInfo[0]?.documents?.driving_license }}"
              >View</a
            >
          </div>
        </div>
      </div>
      <div class="row mb">
        <div class="col-sm-4">
          <div class="head-b">Insurance</div>
        </div>
        <div class="col-sm-4">
          <div class="dec">
            {{
              driverData.registerInfo[0]?.documents?.insurance_expiry
                | date : "dd-MM-yyyy"
            }}
          </div>
        </div>
        <div class="col-sm-4">
          <div class="dec-view">
            <a
              target="_blank"
              href="{{ driverData.registerInfo[0]?.documents.insurance }}"
              >View</a
            >
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="fixed-btn">
        <button
          class="button"
          [class.spinner]="loading"
          [disabled]="loading"
          *ngIf="data?.driver_status != 'rejected'"
          (click)="editDriver()"
        >
          Edit
        </button>
      </div>
    </div>
  </div>
  <!-- --------------- Edit Driver ---------------- -->
  <div *ngIf="editDriverProfile" class="driver-view">
    <div class="heading">
      <h3>Driver Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <form [formGroup]="editDriverFrom" class="admin-forms mt-3">
      <div class="row m-0 input-fileds-container">
        <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 driver-truck">
          <div class="row mtb">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="head">Driver Name</div>
              <div class="dec">
                {{ driverData.registerInfo[0]?.username }}
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="dec">
                {{ driverData.registerInfo[0]?.mobile }}
                <img src="../../../assets/img/tick-verify.svg" />
              </div>
              <div class="dec">
                {{ driverData.registerInfo[0]?.email }}
                <img src="../../../assets/img/tick-verify.svg" />
              </div>
            </div>
          </div>
          <div class="row mb">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="dec">
                <mat-form-field>
                  <div class="head">Driver License Number</div>
                  <input
                    toUppercase
                    appAlphanumericOnly
                    matInput
                    formControlName="driving_license_number"
                    required
                  />
                  <mat-error>License number is required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="head">Expiry Date</div>
              <div class="dec">
                <mat-form-field>
                  <input
                    matInput
                    [matDatepicker]="picker"
                    [min]="today"
                    formControlName="license_expiry_date"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row mb">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="head">Assigned Truck Number</div>
              <div class="dec">
                <mat-form-field appearance="fill">
                  <mat-select formControlName="truck_number">
                    <mat-option value="">Select truck</mat-option>
                    <mat-option
                      *ngFor="let item of truckList"
                      value="{{ item._id }}"
                    >
                      {{ item.truck_number }}</mat-option
                    >
                  </mat-select>
                  <mat-error>Truck number is required</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div class="dec">
                <mat-form-field>
                  <div class="head">Emergency Contact</div>
                  <input
                    matInput
                    (keypress)="validateNumber($event)"
                    maxlength="10"
                    minlength="10"
                    formControlName="emergency_contact"
                    required
                  />
                  <mat-error>Emergency contact is required</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-12 col-sm-12">
          <div class="right-side image">
            <img src="{{ truckImage }}" class="driverImg" />
            <div class="image-upload-area">
              <p>Upload Truck Image</p>
              <button class="mac" (click)="uploadImage.click()">
                Update Profile
              </button>
              <input
                #uploadImage
                type="file"
                (change)="onChange($event, 'Truck')"
                hidden
              />
            </div>
          </div>
          <!-- <div class="right-side">
            <img src="{{ truckImage }}" class="driverImg" />
            <div class="image-upload-area text-center">
              <button class="mac" (click)="uploadImage.click()">
                Update Profile
              </button>
              <input
                #uploadImage
                type="file"
                (change)="onChange($event, 'Truck')"
                hidden
              />
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12">
            <div class="headings">Contact Details</div>
            <div class="row mtb">
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center"
              >
                <div class="head">Name</div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="name" required />
                    <mat-error>Name is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center"
              >
                <div class="head">Email</div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="email" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center"
              >
                <div class="head">Address Line</div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="address_line" required />
                    <mat-error>Address is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center"
              >
                <div class="head">Area</div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="area" required />
                    <mat-error>Area is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center"
              >
                <div class="head">City</div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="city" required />
                    <mat-error>City is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center"
              >
                <div class="head">state</div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="state" required />
                    <mat-error>State is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center"
              >
                <div class="head">Pincode</div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      (keypress)="validateNumber($event)"
                      formControlName="pincode"
                      minlength="6"
                      maxlength="6"
                      required
                    />
                    <mat-error>Pincode is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center"
              >
                <div class="head">Contact Number</div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      (keypress)="validateNumber($event)"
                      formControlName="mobile"
                      maxlength="10"
                      minlength="10"
                      required
                    />
                    <mat-error>Mobile is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div
                class="col-xl-3 col-lg-3 col-md-6 col-sm-12 d-flex align-items-center"
              >
                <div class="head">GST</div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                <div class="">
                  <mat-form-field>
                    <input matInput uppercase formControlName="gst" required />
                    <mat-error>GST is required</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb headings">Documents</div>
        <div class="row align-items-center mb-3">
          <div class="col-xl-3 col-lg-3 col-md-3 mb-3">
            <div class="head">Driving License</div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4">
            <div class="dec">
              <mat-form-field>
                <mat-datepicker-toggle matSuffix [for]="picker4">
                </mat-datepicker-toggle>
                <mat-datepicker #picker4></mat-datepicker>
                <input
                  matInput
                  [matDatepicker]="picker4"
                  placeholder="DD-MM-YYYY"
                  [min]="minDate"
                  formControlName="driving_license_expiry"
                  (click)="picker4.open()"
                  required
                />
              </mat-form-field>
            </div>
          </div>
          <div
            class="col-xl-5 col-lg-5 col-md-5 d-flex align-items-center mb-3"
          >
            <span
              (click)="uploadDrivinglicenseImage.click()"
              *ngIf="uploaddrivingLicense"
              class="image"
              >Upload
            </span>
            <div *ngIf="uploaddrivingLicense">
              <a
                target="_blank"
                href="{{
                  this.driverData.registerInfo[0]?.documents.insurance
                }}"
                >{{ drivinglicenseImageName }}</a
              >
            </div>
            <span *ngIf="!uploaddrivingLicense">{{
              drivinglicenseImageName
            }}</span>
            <img
              src="../../../assets/img/cross.svg"
              *ngIf="!uploaddrivingLicense"
              (click)="removeImg($event, 'driverlicense')"
              class="cross-btn"
              alt=""
            />
            <input
              #uploadDrivinglicenseImage
              type="file"
              (change)="onChange($event, 'driverlicense')"
              hidden
            />
          </div>
        </div>
        <div class="row mb">
          <div
            class="col-xl-3 col-lg-3 col-md-3 mb-3 d-flex align-items-center"
          >
            <div class="head">Insurance</div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 mb-3">
            <div class="dec">
              <mat-form-field>
                <mat-datepicker-toggle matSuffix [for]="picker5">
                </mat-datepicker-toggle>
                <mat-datepicker #picker5></mat-datepicker>
                <input
                  matInput
                  [matDatepicker]="picker5"
                  placeholder="DD-MM-YYYY"
                  [min]="minDate"
                  formControlName="insurance_expiry"
                  (click)="picker5.open()"
                  required
                />
              </mat-form-field>
            </div>
          </div>
          <div
            class="col-xl-5 col-lg-5 col-md-5 d-flex align-items-center mb-3"
          >
            <span
              (click)="uploadInsuranceImage.click()"
              *ngIf="uploadInsurance"
              class="image"
              >Upload
            </span>
            <div *ngIf="updateInsurance">
              <a
                target="_blank"
                href="{{
                  this.driverData.registerInfo[0]?.documents.insurance
                }}"
                >{{ insuranceImageName }}</a
              >
            </div>
            <span *ngIf="!uploadInsurance">{{ insuranceImageName }}</span>
            <img
              src="../../../assets/img/cross.svg"
              *ngIf="!uploadInsurance"
              (click)="removeImg($event, 'insurance')"
              class="cross-btn"
              alt=""
            />
            <input
              #uploadInsuranceImage
              type="file"
              (change)="onChange($event, 'Insurance')"
              hidden
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="fixed-btn">
          <button
            type="button"
            [class.spinner]="loading"
            [disabled]="loading"
            (click)="UpdateDriver()"
            class="button"
          >
            Save
          </button>
        </div>
      </div>
      <!-- <div class="fixed-btn">
        <button
          (click)="UpdateDriver()"
          [class.spinner]="loading"
          [disabled]="loading"
        >
          Save
        </button>
      </div> -->
    </form>
  </div>
</div>
